import { render, staticRenderFns } from "./ActionControl.vue?vue&type=template&id=5a7f0049"
import script from "./ActionControl.vue?vue&type=script&lang=js"
export * from "./ActionControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports